module.exports = function(app) {
	app.run(["Service","sessionData", function (Service, sessionData) {
		return new Service({

			name: 'employeesSearch',
			group: "eprsvc",
			url: "/eprsvc/x-services/secure/employees/v1/search",
			cache: false,

			fetch: function(searchData) {
				searchData = searchData && (searchData instanceof Object)
					? searchData
					: { groupNumber: '', lastName: '', memberId: '', listId: '' };
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.post(searchData).then(
					function(response) {
						if (response && response.data && response.data.payload && Array.isArray(response.data.payload.searchResults)) {

							searchData.listId = response.data.payload.listId;

							var employees = response.data.payload.searchResults.map(
								function(r) {
									var status;
									var groupNumber;

									if (r.activeGroupNumbers && r.activeGroupNumbers.length > 0) {
										status = 'active';
										groupNumber = r.activeGroupNumbers[0];
									}
									else if (r.cancelledGroupNumbers && r.cancelledGroupNumbers.length > 0) {
										status = 'cancelled';
										groupNumber = r.cancelledGroupNumbers[0];
									}

									return {
										firstName: r.firstName,
										lastName: r.lastName,
										umi: r.umi,
										memberId: r.umi,
										clientAssignedId:r.clientAssignedId,
										activeGroupNumbers: r.activeGroupNumbers,
										cancelledGroupNumbers: r.cancelledGroupNumbers,
										status: status,
										groupNumber: groupNumber
									};
								}
							).filter(function(r) { return r.firstName && r.lastName && r.status && r.groupNumber && r.memberId; });

							return {
								employees: employees,
								searchData: searchData
							};
						}
					}
				)
			}
		});
	}]);
};
